var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourceIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108 76",
    width: 108,
    height: 76,
    preserveAspectRatio: "xMidYMid slice",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 76,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_86)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(0,0,0)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M4.664000034332275,47 C0.6639959812164307,31.83340072631836 -1.8359999656677246,1.6000200510025024 20.163999557495117,2.0000200271606445 C36.585201263427734,2.2985899448394775 41.95650100708008,18.958599090576172 42.93159866333008,33.55730056762695 C43.515098571777344,42.29359817504883 33.678199768066406,57.240699768066406 33.164100646972656,48.5 C33.164100646972656,48.5 33.164100646972656,48.5 33.164100646972656,48.5 C32.664100646972656,40 46.664100646972656,12.5 71.16410064697266,16 C90.76409912109375,18.799999237060547 90.33070373535156,46.16669845581055 87.66410064697266,59.5 C86.83070373535156,63.33330154418945 82.56410217285156,70.30000305175781 72.16410064697266,67.5 C59.164100646972656,64 107.66400146484375,31 105.66400146484375,75.5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceIcon02);
export default __webpack_public_path__ + "static/media/ResourceIcon02.cc134113304013227ead6d6f579d4267.svg";
export { ForwardRef as ReactComponent };